import {GameActionCreators} from "../../../store/reducers/game/action-creators";
import Table from "./Table";
import {sounds} from "../../../sounds/sound";
import {store} from "../../../store";
import {SoundsService} from "../../SoundsService";
import {AnimationActionCreators} from "../../../store/reducers/animation/action-creation";

export default class UnitFight {

    static async fight(serverState, dispatch) {

        let state = store.getState();
        if (state.game.phase === 'end_game') {
            return;
        }

        let damageToEnemy = false;
        if (serverState.sideD === undefined) {
            damageToEnemy = true;
        }
        dispatch(AnimationActionCreators.setShowUnitAttack({
            tableKey: serverState.tableKey,
            side: serverState.sideA,
            damageToEnemy: damageToEnemy
        }));

        let table = state.game.playerTable;
        if (serverState.sideA === 'cpu') {
            table = state.game.cpuTable;
        }

        if (table[serverState.tableKey].card.attack === 1) {
            SoundsService.playSound(sounds.battle_unit_fight_very_low());
        } else if (table[serverState.tableKey].card.attack === 2 || table[serverState.tableKey].card.attack === 3) {
            SoundsService.playSound(sounds.battle_unit_fight_low());
        } else if (table[serverState.tableKey].card.attack > 2) {
            SoundsService.playSound(sounds.battle_unit_fight_medium());
        }

        await new Promise(r => setTimeout(r, 500));

        dispatch(AnimationActionCreators.setShowUnitAttack({
            tableKey: null,
            side: null,
            damageToEnemy: false
        }));

        let playerAd = state.game.playerAD;
        playerAd[serverState.tableKey] = false;
        dispatch(GameActionCreators.setPlayerAD(playerAd))

        if (serverState.sideD !== undefined) { // dont update if attack HP
            await Table.set(serverState.sideA, serverState.attacking, dispatch, serverState.tableKey);

            await Table.set(serverState.sideD, serverState.defend, dispatch, serverState.tableKey);

            await new Promise(r => setTimeout(r, 300));
        }
    }
}
